import { render, staticRenderFns } from "./SoftDeletedLinks.vue?vue&type=template&id=13266c28&"
import script from "./SoftDeletedLinks.vue?vue&type=script&lang=js&"
export * from "./SoftDeletedLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports